var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    staticClass: "form-control-file form-control-sm",
    class: _vm.inputclass,
    attrs: { type: "file", accept: _vm.accept, multiple: _vm.multiple },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }